import { render, staticRenderFns } from "./ReleaseListItem.vue?vue&type=template&id=8026d1e0&scoped=true&lang=pug&"
import script from "./ReleaseListItem.vue?vue&type=script&lang=js&"
export * from "./ReleaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseListItem.vue?vue&type=style&index=0&id=8026d1e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8026d1e0",
  null
  
)

export default component.exports